"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _uiKit = require("@devsta/ui-kit");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

require("../styles/_team-summary.scss");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _commonReact = require("@devsta/common-react");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TeamSummary = /*#__PURE__*/function (_Component) {
  _inherits(TeamSummary, _Component);
  /**
   * @param {Function} fn
   *
   * @return {Function}
   *
   * Prevent event propogation to parent DOM elements.
   * Parent DOM elements onClick handlers should not be triggered.
   *
   */

  /**
   * Capture ActionPopup ref
   */


  function TeamSummary(props) {
    var _this;

    _classCallCheck(this, TeamSummary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TeamSummary).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "withNoEventPropagation", (0, _memoizeOne.default)(function (fn) {
      return function (e) {
        e.stopPropagation();
        e.preventDefault();
        fn(e);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "wrapPopupOptionsWithStopEvent", (0, _memoizeOne.default)(function (popupOptions) {
      return popupOptions.map(function (option) {
        return _objectSpread({}, option, {
          action: _this.withNoEventPropagation(option.action)
        });
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "setActionPopupRef", (0, _memoizeOne.default)(function (el) {
      if (!el) {
        return;
      } // eslint-disable-next-line react/no-find-dom-node


      _this.setState({
        actionBtnRef: _reactDom.default.findDOMNode(el)
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "getActionOptions", (0, _lodash.default)(function () {
      var _this$props = _this.props,
          orgPermissions = _this$props.orgPermissions,
          deleteTeam = _this$props.deleteTeam,
          teamPreview = _this$props.teamPreview,
          onDeleteSuccess = _this$props.onDeleteSuccess,
          onClick = _this$props.onClick;
      var deleteAction = (0, _lodash.default)(function (teamId) {
        return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var _ref2, error;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return deleteTeam({
                      teamId: teamId
                    });

                  case 2:
                    _ref2 = _context.sent;
                    error = _ref2.error;

                    if (!error) {
                      // Team deleted, update the teams state in ManageTeams
                      onDeleteSuccess(teamId);
                    }

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))
        );
      });
      var actionOptions = [{
        action: onClick,
        label: 'Manage Users',
        requiredPermission: 'MANAGE_TEAM'
      }, {
        action: deleteAction(teamPreview.teamId),
        label: 'Delete Team',
        isRed: true,
        requiredPermission: 'MANAGE_TEAM'
      }];
      return actionOptions.filter(function (_ref3) {
        var requiredPermission = _ref3.requiredPermission;
        return !requiredPermission || (0, _commonReact.hasPermission)(requiredPermission, orgPermissions);
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "interceptClick", function (onClick) {
      return _this.withNoEventPropagation(function (e) {
        var actionBtnRef = _this.state.actionBtnRef;

        if (actionBtnRef && actionBtnRef.contains(e.target) || !onClick) {
          return;
        }

        onClick(e);
      });
    });

    _this.state = {};
    return _this;
  }

  _createClass(TeamSummary, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          teamPreview = _this$props2.teamPreview,
          onClick = _this$props2.onClick;
      var name = teamPreview.name,
          description = teamPreview.description,
          membersPreview = teamPreview.membersPreview,
          membersCount = teamPreview.membersCount,
          type = teamPreview.type,
          imageUrl = teamPreview.imageUrl;
      return _react.default.createElement("div", {
        onClick: this.interceptClick(onClick),
        onKeyPress: (0, _onEnterPressed.default)({
          onClick: this.interceptClick(onClick)
        }),
        className: "team-summary",
        role: "button",
        tabIndex: 0
      }, _react.default.createElement("div", {
        className: "team-summary-image"
      }, _react.default.createElement(_uiKit.Image, {
        width: "90px",
        height: "90px",
        defaultImageIcon: "shootstagrad",
        defaultIconColour: "regent",
        imageUrl: imageUrl
      })), _react.default.createElement("div", {
        className: "team-summary-content"
      }, _react.default.createElement("div", {
        className: "team-summary-header"
      }, _react.default.createElement("div", {
        className: "team-summary-header__container"
      }, _react.default.createElement("div", {
        className: "team-summary__name",
        title: name
      }, name), type === 'EDITING' && _react.default.createElement("div", {
        className: "team-summary__edit-indicator"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "desktop",
        color: "black",
        size: "16"
      }))), _react.default.createElement(_uiKit.ActionPopup, {
        popupBtn: _react.default.createElement(_uiKit.Icon, {
          name: "options",
          color: "regent"
        }),
        options: this.wrapPopupOptionsWithStopEvent(this.getActionOptions()),
        ref: this.setActionPopupRef
      })), _react.default.createElement("p", {
        className: "team-summary__description"
      }, description), _react.default.createElement("div", {
        className: "team-summary__members"
      }, _react.default.createElement("div", {
        className: "team-summary__members__count"
      }, "".concat(membersCount, " USER").concat(membersCount !== 1 ? 'S' : '')), _react.default.createElement("div", {
        className: "team-summary__members__list"
      }, _react.default.createElement(_uiKit.ResourceMembers, {
        members: membersPreview,
        totalMembers: membersCount,
        imageSize: 25
      })))));
    }
  }]);

  return TeamSummary;
}(_react.Component);

exports.default = TeamSummary;

_defineProperty(TeamSummary, "displayName", 'TeamSummary');